import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import { Checkbox, FormControlLabel, Typography } from "@mui/material";
import theme from "../../theme";

const Item = styled(Paper)(({ theme }) => ({
  boxShadow: "none",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

interface InStockOnlyFilterProps {
  inStockOnly: boolean;
  onInStockOnlyChange: (checked: boolean) => void;
}

const InStockOnlyFilter = ({ inStockOnly, onInStockOnlyChange }: InStockOnlyFilterProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked;
    const urlParams = new URLSearchParams(window.location.search);

    if (checked) {
      urlParams.set("inStockOnly", "1");
    } else {
      urlParams.delete("inStockOnly");
    }

    const newUrl = `${window.location.origin}${window.location.pathname}?${urlParams.toString()}`;
    window.history.pushState({}, "", newUrl);
    onInStockOnlyChange(checked);
  };

  return (
    <Box sx={{ width: "100%", border: "4px solid #f1f1f1", mb: 3 }}>
      <Item sx={{ display: "flex", flexWrap: "wrap", p: 1, textAlign: "left" }}>
        <FormControlLabel
          label={
            <Typography
              sx={{
                fontSize: "13px",
                fontFamily: "Inter",
                fontWeight: "normal",
              }}
            >
              Nur verfügbare Produkte
            </Typography>
          }
          labelPlacement="end"
          control={
            <Checkbox
              checked={inStockOnly}
              onChange={handleChange}
              inputProps={{ "aria-label": "Nur verfügbare Produkte" }}
              sx={{
                color: theme.palette.secondary.main,
                "&.Mui-checked": {
                  color: theme.palette.secondary.main,
                },
              }}
            />
          }
          sx={{
            color: theme.palette.text.primary,
            width: "100%",
            m: 0,
          }}
        />
      </Item>
    </Box>
  );
};

export default InStockOnlyFilter;
